<template>
  <div></div>
</template>

<script>
export default {
  name: "property-data-layer",
  props: ["name", "price", "property", "listing_type"],
  mounted() {
    if (dataLayer) {
      dataLayer.push({
        event: "view_item",
        ecommerce: {
          items: [
            {
              item_id: this.property.id,
              item_name: this.name,
              price: this.addComma(this.price),
              item_category: this.listing_type,
              item_category_2: this.property.category,
              item_list_name: "Property detail",
            },
          ],
        },
      });
    }
  },
  methods: {
    addComma: function (num) {
      if (num != null) {
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      } else {
        return "";
      }
    },
  },
};
</script>
